import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Input, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

import { DatePicker } from '../../UI/DatePicker';
import { Currency } from '../../UI/Input';

import { DeleteBtn, PlusBtn } from '../../../Buttons';
import { AddableEmptyMessage } from '../EmptyMessage';
// import { Field } from 'formik';


export default class AddableDebiti extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: props.elements || [],
    };
  }

  onInputDelete = (item) => {
    const items = _.cloneDeep(this.state.items);

    _.remove(items, (i) => i.key ? i.key === item.key : i.id === item.id);
    this.setState({ items });
    this.props.onChange(this.props.type, items);
  }

  onInputChange = (e, item, cb) => {
    const items = [].concat(this.state.items);
    const index = item.id ? _.findIndex(items, { id: item.id }) : _.findIndex(items, { key: item.key });
    const itemData = { ...items[index] };
    itemData[e.target.name] = e.target.value;
    items[index] = itemData;
    this.setState({ items }, cb ? this.props.onChange(this.props.type, items) : () => {});
  }

  onDateChange = (name, date, item) => {
    const items = [].concat(this.state.items);
    const index = item.id ? _.findIndex(items, { id: item.id }) : _.findIndex(items, { key: item.key });
    const itemData = { ...items[index] };
    itemData[name] = date;
    items[index] = itemData;
    this.setState({ items }, () => {
      this.props.onChange(this.props.type, items);
    }
    );
  }

  renderInput = (e) => {
    e.preventDefault();
    const items = _.cloneDeep(this.state.items);
    items.unshift({
      istituto: null,
      importo: null,
      scadenza: null,
      key: Date.now(),
    });
    this.setState({ items });
  }

  render() {
    return (
      <div>
        <Grid style={{ marginBottom: 0 }}>
          <Grid.Column width={16}>
            <Divider horizontal style={{ marginBottom: 5 }}>{this.props.label}<PlusBtn action={this.renderInput} /></Divider>
          </Grid.Column>
          {(!this.state.items || this.state.items.length === 0) && <Grid.Column width={16} style={{ marginTop: -15 }}> <AddableEmptyMessage /></Grid.Column>}
        </Grid>
        {this.state.items.map((item) => (
          <Grid key={item.id || item.key} style={{ marginTop: -18 }}>
            <Grid.Column width={5} className="field">
              <label htmlFor="istituto">Istituto</label>
              <Input
                value={item.istituto ? item.istituto : ''}
                fluid
                name="istituto"
                onChange={(e) => this.onInputChange(e, item)}
              //  onBlur={() => this.props.onChange(this.props.type, this.state.items)}
              />
            </Grid.Column>
            <Grid.Column width={4} className="field">
              <label htmlFor="importo">Importo rata</label>
              <Currency
                values={{ importo: item.importo ? item.importo : '' }}
                fluid
                name="importo"
                setFieldValue={(name, value) => this.onInputChange({ target: { name: 'importo', value } }, item, true)}
                errors={{}}
                touched={{}}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <DatePicker
                {...this.props}
                value={item.scadenza ? item.scadenza : ''}
                onChange={(name, date) => this.onDateChange(name, date, item)}
                onBlur={() => this.props.onChange(this.props.type, this.state.items)}
                name="scadenza"
                label="Data scadenza"
                startDate={moment()}
                openDirection="up"
              />
            </Grid.Column>
            <Grid.Column width={2} textAlign="center" verticalAlign="middle">
              <DeleteBtn action={() => this.onInputDelete(item)} />
            </Grid.Column>
          </Grid>
        ))}
      </div>
    );
  }
}

AddableDebiti.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  elements: PropTypes.array,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/AddableDebiti/index.js